import "./CreateUser.css";

import { Breadcrumb, Button, Checkbox, Form, Input, message } from "antd";
import { useEffect } from "react";
import { BsTrash } from "react-icons/bs";
import { CgScreen } from "react-icons/cg";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  createUser,
  deleteUser,
  updateUser,
  useAppSelector,
  type UserFormType,
} from "../../../_lib/_store";

interface CreateUserPageProps {
  type: "create" | "edit";
}

export const CreateUserPage = ({ type }: CreateUserPageProps) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { isLoading } = useAppSelector((state) => state.user);
  const navigate = useNavigate();
  const { state } = useLocation();

  const isEdit = type === "edit";

  useEffect(() => {
    const userObj = state?.user;
    if (isEdit && !userObj) {
      navigate("/user");
    }
    if (isEdit) {
      form.setFieldsValue(userObj);
    }
  }, [state]);

  const handleSubmit = async (values: UserFormType) => {
    const payload = {
      ...values,
      isRegistrationComplete: values?.isRegistrationComplete ? true : false,
      emailVerified: values?.emailVerified ? true : false,
      purchaseFlag: values?.purchaseFlag ? true : false,
      ...(isEdit ? { id: state.user.id } : {}),
    };

    if (isEdit) {
      const res = await updateUser(messageApi, payload);
      if (res) {
        navigate("/user/edit", {
          state: { user: res },
          replace: true,
        });
      }
    } else {
      const res = await createUser(messageApi, payload);
      if (res) {
        form.resetFields();
      }
    }
  };

  const handleDelete = async () => {
    const res = await deleteUser(messageApi, state.user.id);
    if (res) {
      navigate("/user");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createPackage">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/user">User</Link>,
            },
            {
              title: isEdit ? "Edit" : "Create new",
            },
          ]}
        />

        {!isEdit ? (
          <h2 className="title">Create new</h2>
        ) : (
          <div className="titleHeader">
            <h2 className="title">Edit</h2>
            <div className="actionButton">
              <Button
                icon={<CgScreen size={17} />}
                size="large"
                onClick={() =>
                  navigate(`/user/show`, {
                    state: { user: state?.user },
                  })
                }
              >
                Show
              </Button>
              <Button
                icon={<BsTrash />}
                size="large"
                onClick={handleDelete}
                loading={isLoading}
              >
                Delete
              </Button>
            </div>
          </div>
        )}

        <div className="form">
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Email is required" }]}
              tooltip="Email is required."
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="Full Name"
              name="fullName"
              rules={[{ required: true, message: "Full name is required" }]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: isEdit ? false : true,
                  message: "Password is required",
                },
              ]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label=""
              name="isRegistrationComplete"
              valuePropName="checked"
            >
              <Checkbox>Is Registration Complete</Checkbox>
            </Form.Item>

            {/* <Form.Item
              label="Role"
              name="role"
              rules={[{ required: true, message: "Role is Required" }]}
              tooltip="User role is required"
            >
              <Select
                size="large"
                options={[
                  { value: "SUPER_ADMIN", label: "SUPER_ADMIN" },
                  { value: "USER", label: "USER" },
                  { value: "AUDITOR", label: "AUDITOR" },
                ]}
              />
            </Form.Item> */}

            <Form.Item
              label=""
              name="emailVerified"
              rules={[]}
              valuePropName="checked"
            >
              <Checkbox>Email Verified</Checkbox>
            </Form.Item>

            <Form.Item label="" name="purchaseFlag" valuePropName="checked">
              <Checkbox>Purchase Flag</Checkbox>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                style={{ width: "150px" }}
                loading={isLoading}
              >
                {isEdit ? "Update" : "Save"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
};
